"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentDeliveryRpcLocal = void 0;
const dht_1 = require("@streamr/dht");
const empty_1 = require("../../generated/google/protobuf/empty");
class ContentDeliveryRpcLocal {
    options;
    constructor(options) {
        this.options = options;
    }
    async sendStreamMessage(message, context) {
        const previousNode = context.incomingSourceDescriptor;
        const previousNodeId = (0, dht_1.toNodeId)(previousNode);
        this.options.markForInspection(previousNodeId, message.messageId);
        if (this.options.plumTreeManager === undefined) {
            if (this.options.markAndCheckDuplicate(message.messageId, message.previousMessageRef)) {
                this.options.broadcast(message, previousNodeId);
            }
        }
        else if (this.options.markAndCheckDuplicate(message.messageId, message.previousMessageRef)) {
            // Message is not a duplicate, so we can broadcast it over the plumtree
            this.options.plumTreeManager.broadcast(message, previousNodeId);
        }
        else {
            // Message is a duplicate, so we need to pause the neighbor
            await this.options.plumTreeManager.pauseNeighbor(previousNode, message.messageId.messageChainId);
        }
        return empty_1.Empty;
    }
    async leaveStreamPartNotice(message, context) {
        if (message.streamPartId === this.options.streamPartId) {
            const sourcePeerDescriptor = context.incomingSourceDescriptor;
            const remoteNodeId = (0, dht_1.toNodeId)(sourcePeerDescriptor);
            this.options.onLeaveNotice(remoteNodeId, message.isEntryPoint);
        }
        return empty_1.Empty;
    }
}
exports.ContentDeliveryRpcLocal = ContentDeliveryRpcLocal;
//# sourceMappingURL=ContentDeliveryRpcLocal.js.map